<template>
  <div class="relative w-full overflow-hidden  md:max-w-[670px] mx-auto">
    <div
      class="flex transition-transform duration-500"
      :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
    >
      <div v-for="(image, index) in images" :key="index" class="min-w-full">
        <img
          :src="image"
          alt="Slider Image"
          class="w-full h-auto object-cover"
        />
      </div>
    </div>
    <!-- Navigation Buttons -->
    <button
      @click="prevSlide"
      class="absolute top-1/2 left-0 transform -translate-y-1/2 bg-black bg-opacity-50 text-white px-2 py-1"
    >
      ย้อนกลับ
    </button>
    <button
      @click="nextSlide"
      class="absolute top-1/2 right-0 transform -translate-y-1/2 bg-black bg-opacity-50 text-white px-2 py-1"
    >
      ถัดไป
    </button>
  </div>
</template>

<script>
export default {
  name: "Slider",
  data() {
    return {
      currentIndex: 0,
      images: [
        require("@/assets/slide/1.jpg"),
        require("@/assets/slide/2.jpg"),
        require("@/assets/slide/3.jpg"),
      ],
    };
  },
  methods: {
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    },
    prevSlide() {
      this.currentIndex =
        (this.currentIndex - 1 + this.images.length) % this.images.length;
    },
  },
  mounted() {
    // Auto-slide functionality
    this.autoSlide = setInterval(this.nextSlide, 3000);
  },
  beforeUnmount() {
    // Clear interval when component is destroyed
    clearInterval(this.autoSlide);
  },
};
</script>

<style scoped>
/* คุณสามารถปรับแต่งสไตล์เพิ่มเติมได้ที่นี่ */
.min-w-full {
  min-width: 100%;
}
</style>
